"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Ger Array Index
 * @description get array index from given string
 * @param {string} str
 * @return {string[]|null}
 */
var getArrayIndex = function getArrayIndex(str) {
  return getArrayIndex.regexNaNIndex.exec(str) || getArrayIndex.regexIntegerIndex.exec(str);
};

getArrayIndex.regexIntegerIndex = /\[([-]*\d*)\]/g;
getArrayIndex.regexNaNIndex = /\[([^\]]*)\]/;
var _default = getArrayIndex;
exports.default = _default;